<form [formGroup]="formColegiatura" class="mb-5">
  <p-card header="Simulador de colegiatura de Preparatoria y Profesional">
    <div class="mb-3">
      <app-label-tooltip for="nivelAcademico" [isRequired]="true" styleClass="mb-1" titleLabel="Nivel Académico"
        etiqueta="niveles"></app-label-tooltip>
      <p-dropdown [options]="dataNivelAcademico" formControlName="nivelAcademico" optionLabel="nivel"
        [placeholder]="paceholder" [style]="{ width: '100%' }"
        [emptyMessage]="firstEmptyPaceholder.niveles.value"></p-dropdown>
    </div>
    <div class="mb-3">
      <app-label-tooltip for="periodo" [isRequired]="true" styleClass="mb-1" titleLabel="Periodo Académico"
        etiqueta="periodos"></app-label-tooltip>
      <p-dropdown [options]="dataPeriodos" formControlName="periodo" [placeholder]="paceholder"
        [style]="{ width: '100%' }" [emptyMessage]="firstEmptyPaceholder.periodo.value">
        <ng-template pTemplate="selectedItem">
          <div class="d-flex align-items-center justify-content-between" *ngIf="periodo.valid">
            <div>{{ periodo?.value.periodo }}</div>
            <div class="color-gray creditos">
              {{ periodo?.value.creditos }} créditos
            </div>
          </div>
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="d-flex align-items-center justify-content-between">
            <div>{{ country.periodo }}</div>
            <div class="color-gray creditos">
              {{ country.creditos }} créditos
            </div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="mb-3">
      <app-label-tooltip for="campus" [isRequired]="true" styleClass="mb-1" titleLabel="Campus"
        etiqueta="campi"></app-label-tooltip>
      <p-dropdown [options]="dataCampus" formControlName="campus" optionLabel="sede" [placeholder]="paceholder"
        [style]="{ width: '100%' }" [emptyMessage]="firstEmptyPaceholder.campus.value"></p-dropdown>
    </div>
    <div class="mb-3" *ngIf="nivelAcademico?.value?.clave !== claveNivelAcademico">
      <app-label-tooltip for="area" [isRequired]="true" styleClass="mb-1" titleLabel="Área"
        etiqueta="areas"></app-label-tooltip>
      <p-dropdown [options]="dataAreas" formControlName="area" optionLabel="area" [placeholder]="paceholder"
        [style]="{ width: '100%' }" (onChange)="validarPorcentajeMaximo()"
        [emptyMessage]="firstEmptyPaceholder.area.value"></p-dropdown>
    </div>
    <div class="mb-3">
      <app-label-tooltip for="programa" [isRequired]="true" styleClass="mb-1" titleLabel="Programa Académico"
        etiqueta="programas"></app-label-tooltip>
      <p-dropdown [options]="dataProgramas" formControlName="programa" optionLabel="programa" [placeholder]="paceholder"
        [style]="{ width: '100%' }" (onChange)="validarPorcentajeMaximo()"
        [emptyMessage]="firstEmptyPaceholder.programa.value"></p-dropdown>
    </div>
  </p-card>

  <p-card header="¿Deseas personalizar el costo de colegiatura y seguro?" styleClass="mt-3 beca">
    <p class="fw-bold">Apoyos financieros</p>
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <app-label-tooltip for="beca" styleClass="mb-1" titleLabel="Beca" etiqueta="beca"
          [isRequired]="false"></app-label-tooltip>
        <p-dropdown [options]="dataBeca" [showClear]="true" formControlName="beca" optionLabel="porcentaje"
          [placeholder]="paceholder" [style]="{ width: '100%' }" (onChange)="validarPorcentajeMaximo()"
          [emptyMessage]="firstEmptyPaceholder.beca.value"></p-dropdown>
      </div>
      <div class="col-12 col-md-6 mb-3" *ngIf="nivelAcademico?.value?.clave !== claveNivelAcademico">
        <app-label-tooltip for="prestamos" styleClass="mb-1" [titleLabel]="'Préstamo Educativo'"
          etiqueta="prestamosEducativo" [isRequired]="false"></app-label-tooltip>
        <p-dropdown [options]="dataPrestamos" [showClear]="true" formControlName="prestamos" optionLabel="porcentaje"
          [placeholder]="paceholder" [style]="{ width: '100%' }" (onChange)="validarPorcentajeMaximo()"
          [emptyMessage]="firstEmptyPaceholder.prestamo.value"></p-dropdown>
      </div>
    </div>
    <div class="row mt-2">
      @if (hasErrorLimiteSuperior) {
      <div class="alert alert-danger" role="alert">        
        El apoyo financiero debe ser un equilibrio de Beca + Préstamo Educativo no mayor al {{ limiteSuperior }}%
      </div>
      }
    </div>

    <p class="text-start text-description" [innerHtml]="textoApoyos"></p>
    @if (formColegiatura.valid) {
    <div class="mb-3">
      <label for="campus">¿Deseas contratar el Seguro de Gastos Médicos Mayores?</label>

      <div class="d-flex justify-content-start">
        @for (category of categories; track category.id) {
        <div class="field-checkbox d-flex justify-content-center align-items-center">
          <p-radioButton [inputId]="category?.key" [value]="category.value"
            formControlName="gastosMedicosMayores"></p-radioButton>
          <label [for]="category.key" class="label-spacing m-2">{{
            category.name
            }}</label>
        </div>
        }
      </div>
    </div>
    @if (gastosMedicosMayores?.value) {
    <div class="mb-3">
      <app-label-tooltip for="seguro" [isRequired]="true" styleClass="mb-1"
        titleLabel="Selecciona el tipo de Seguro de Gastos Médicos Mayores:" etiqueta="seguro"
        [isRequired]="false"></app-label-tooltip>
      <p-dropdown [options]="dataApoyos" formControlName="apoyos" optionLabel="apoyo" [placeholder]="paceholder"
        [style]="{ width: '100%' }" (onChange)="validarPorcentajeMaximo()"
        [emptyMessage]="firstEmptyPaceholder.apoyos.value"></p-dropdown>
    </div>
    }
    <p class="text-start text-description" [innerHtml]="textoSeguro"></p>
    }
  </p-card>
</form>
